import { Box, Typography } from '@mui/material';
import { formatTranslation } from 'intl';
import { AnalyticsTranslationKeys } from 'intl/keys';
import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { CHART_FONT_FAMILY } from '../theme/muiChartSlotProps';

type DonutChartCenterTotalProps = Readonly<{
  total: number;
}>;

export function DonutChartCenterTotal({
  total,
}: DonutChartCenterTotalProps): ReactElement {
  const intl = useIntl();

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        textAlign: 'center',
      }}
    >
      <Typography
        variant='caption'
        sx={{
          fontFamily: CHART_FONT_FAMILY,
          color: 'text.secondary',
          lineHeight: 1.2,
        }}
      >
        {formatTranslation(intl, AnalyticsTranslationKeys.donutCenterTotal)}
      </Typography>
      <Typography
        variant='h5'
        sx={{
          fontFamily: CHART_FONT_FAMILY,
          fontWeight: 700,
          lineHeight: 1.1,
        }}
      >
        {Math.floor(total)}
      </Typography>
    </Box>
  );
}
